
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {translate} from 'react-i18next'
import {withStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'

import * as actions from '../../../actionTypes'
import { timeoutPromise } from '../../../utils'

const styles = theme => ({
  button: {
    backgroundColor: 'inherit',
    border: '1px solid #569bca',
    color: '#569bca'
  },
  buttonProgress: {...theme.button.progress},
  pdfGenerationError: {color: theme.palette.error.main},
  root: {
    alignItems: 'center',
    display: 'flex',
    float: 'right'
  },
  wrapper: {position: 'relative'}
})

class GeneratePdfReport extends Component {

  componentDidUpdate(prevProps) {
    if(prevProps.pdfURL !== this.props.pdfURL) {
      this.openPdf(this.props.pdfURL)
    }
  }

  // onBlur swallows onClick 
  handleClick(printLang) {
    this.setState({isRequestingPdf: true})
    this.props.generatePdfReport(this.props.sessionId, printLang)
  }

  // Use handleFocus, if disablePdf the session is being saved. Timeout to the longest
  // save will probably take then start downloading
  handleFocus() {
    if(this.props.disablePdf)
      timeoutPromise().then(() => this.handleClick())
  }

  openPdf(pdfURL) {
    window.open(pdfURL)
  }

  render() {
    const {classes, isRequestingPdf, pdfGenerationError, t} = this.props
    return (
      <div className={classes.root}>
        {this.props.lang === this.props.langGlobal && (
          <div className={classes.wrapper}>
            <Button
              className={classes.button}
              disabled={isRequestingPdf}
              onClick={() => this.handleClick(this.props.lang)}
              onFocus={() => this.handleFocus()}
              variant="contained"
            >
              {t('Print Page')}
            </Button>
          </div>
        )}
        {this.props.lang !== this.props.langGlobal && (
          <div className={classes.wrapper}>
            <Button
              className={classes.button}
              disabled={isRequestingPdf}
              onClick={() => this.handleClick(this.props.lang)}
              onFocus={() => this.handleFocus()}
              variant="contained"
            >
              {t('Print Page')} - {this.props.lang}
            </Button>
            <Button
              style={{marginLeft: 15}}
              className={classes.button}
              disabled={isRequestingPdf}
              onClick={() => this.handleClick(this.props.langGlobal)}
              onFocus={() => this.handleFocus()}
              variant="contained"
            >
              {t('Print Page')} - {this.props.langGlobal}
            </Button>
          </div>
        )}
        <div className={classes.wrapper}>
          {isRequestingPdf && (
            <CircularProgress
              className={classes.buttonProgress}
              size={24}
            />
          )}
          {pdfGenerationError && (
            <Typography variant="body2" className={classes.pdfGenerationError}>
              Sorry, we were unable to generate a PDF file. Please try again later.
            </Typography>
          )}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  generatePdfReport(sessionId, lang) {
    const action = {type: actions.SESSION_REPORT_PDF_GENERATION_REQUESTED, payload: {lang, sessionId}}
    dispatch(action)
  }
})

const mapStateToProps = state => ({
  isRequestingPdf: state.counselingSession.isRequestingPdf,
  lang: state.counselingSession.counselingSessionData.primaryLanguageCode,
  langGlobal: state.globalSettings.lang,
  pdfGenerationError: state.counselingSession.errors.pdfGenerationError,
  pdfURL: state.counselingSession.pdfURL,
  sessionId: state.counselingSession.sessionId
})

GeneratePdfReport.propTypes = {
  disablePdf: PropTypes.bool.isRequired
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
  withStyles(styles)
)(GeneratePdfReport)


// WEBPACK FOOTER //
// ./src/components/counseling-session/report/GeneratePdfReport.js